/* XAPE: make Monster ShipProtect reliable.
   The app only adds its £1.95 "Shipping Protection" item when Check out is clicked, and the theme's
   checkout submit fires at the same time, so the page leaves before the add finishes.
   This waits for the add (or removal) to finish, then goes to checkout. */
(function () {
  if (window.__xapeSP) return; window.__xapeSP = true;
  var VID = 54507349606737, VENDOR = 'monster-shipprotect', busy = false;
  function isSP(i) { return i.variant_id === VID || String(i.vendor || '').toLowerCase() === VENDOR; }
  /* Trust the box the shopper can see. The app's widget is redrawn unticked after a quantity change
     while its global flag stays true, so the flag alone would charge for a box that looks unticked. */
  function ticked(btn) {
    var scope = (btn && btn.closest && btn.closest('cart-drawer, #CartDrawer')) || document.querySelector('#MainContent') || document;
    var s = scope.querySelector('.monster-protection .mp-monsterCheckbox svg');
    if (s) { var on = !s.classList.contains('opacity-0'); window.monster_protection_selected = on; return on; }
    return window.monster_protection_selected === true;
  }
  function j(url, body) {
    return fetch(url, body ? { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) }
                          : { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); });
  }
  /* want = true: exactly one protection line; want = false: none */
  function sync(want) {
    return j('/cart.js').then(function (cart) {
      var lines = cart.items.filter(isSP), p = Promise.resolve();
      lines.forEach(function (l, n) {
        var q = want && n === 0 && l.variant_id === VID ? 1 : 0;
        if (l.quantity !== q) p = p.then(function () { return j('/cart/change.js', { id: l.key, quantity: q }); });
      });
      if (want && !lines.some(function (l) { return l.variant_id === VID; }))
        p = p.then(function () { return j('/cart/add.js', { items: [{ id: VID, quantity: 1 }] }); });
      return p;
    }).then(function () { window.monster_protection_added = !!want; });
  }
  function go(btn) {
    if (busy) return; busy = true;
    var want = ticked(btn);
    if (btn) { btn.setAttribute('aria-busy', 'true'); btn.classList.add('loading'); }
    var done = false;
    function leave() {
      if (done) return; done = true;
      var dp = window.mu_get_discount ? Promise.resolve(window.mu_get_discount()).catch(function () { return null; }) : Promise.resolve(null);
      dp.then(function (d) { window.location.href = d && d.code ? '/checkout?discount=' + encodeURIComponent(d.code) : '/checkout'; });
    }
    setTimeout(leave, 8000); /* never trap a shopper at checkout */
    sync(want).catch(function (e) { try { console.warn('XAPE ShipProtect', e); } catch (x) {} }).then(leave);
  }
  function isCheckoutBtn(el) {
    if (!el || !el.closest) return null;
    var b = el.closest('[name="checkout"]');
    if (!b) return null;
    return (b.closest('cart-drawer, #CartDrawer, #main-cart-footer, cart-items, form#cart, form#CartDrawer-Form') || b.form && /^(cart|CartDrawer-Form)$/.test(b.form.id)) ? b : null;
  }
  window.addEventListener('click', function (e) {
    var b = isCheckoutBtn(e.target);
    if (!b || b.disabled) return;
    if (!ticked(b) && !window.monster_protection_added) return; /* nothing to do: normal checkout */
    e.preventDefault(); e.stopImmediatePropagation();
    go(b);
  }, true);
  window.addEventListener('submit', function (e) {
    var f = e.target, s = e.submitter;
    if (!f || !/^(cart|CartDrawer-Form)$/.test(f.id)) return;
    if (s && s.name !== 'checkout') return;
    if (!ticked(s) && !window.monster_protection_added) return;
    e.preventDefault(); e.stopImmediatePropagation();
    go(s || null);
  }, true);
  /* back button from checkout restores the old page without reloading: drop the item again
     (the app does this itself on a normal page load) and re-enable the button */
  window.addEventListener('pageshow', function (e) {
    busy = false;
    document.querySelectorAll('[name="checkout"][aria-busy]').forEach(function (b) { b.removeAttribute('aria-busy'); b.classList.remove('loading'); });
    if (e.persisted) sync(false).catch(function () {});
  });
})();
